<template>
  <div id="parentFiles">
     <v-container class="pa-0">
      <v-layout>
        <v-flex class="xs12 sm12" style="min-height:70px;">
          <v-btn fab absolute to="dashboard" left class="ml-3 pf-btn-fab">
            <v-icon>arrow_back</v-icon>
          </v-btn>
          <v-btn fab absolute right to="/fileAdd" class="mr-3 pf-btn-fab">
            <v-icon>add</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container>
      <v-card>
      <v-card-title>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search by File Name / Description"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        disable-initial-sort
        :headers="headers"
        :items="File"
        :search="search"
        class="pf-data-table"
        :pagination.sync="pagination" 
      >
        <template v-slot:items="props">
          <td>{{ props.item.name }}</td>
          <td>
          <v-edit-dialog
              :return-value.sync="props.item.description"
              lazy
              large
              @save="fileEdit(props.item, 'Description')"
            > {{ props.item.description ? props.item.description : '--' }}
              <template v-slot:input>
                <v-text-field
                  v-model.trim="props.item.description"
                  label="Description"
                  single-line
                  @keyup.enter="fileEdit(props.item, 'Description')"
                ></v-text-field>
              </template>
            </v-edit-dialog>
            </td>
            <td>
              <v-select
              v-model="props.item.category"
              @change="fileEdit(props.item, 'Category')"
              :items="fileCategoryList"
              item-text="name"
              item-value="id"
              :rules="[category.Rule]"
            >
            </v-select>
            </td>
          <td>{{ formatDate(props.item.createdAt) }}</td>
          <td align="right">
            <v-btn icon class="ma-0" target="_blank" :href="config.uploadPath + props.item.webPath">
              <v-icon size="22" color="grey darken-2">save_alt</v-icon>
            </v-btn> 
            <v-btn icon class="ma-0" v-on:click="deleteItem(props.item);">
              <v-icon size="22" color="grey darken-2">delete_outline</v-icon>
            </v-btn>
          </td>
        </template>
      </v-data-table>
    </v-card>
    </v-container>
    <v-container>
      <v-layout wrap class="pr-4">
        <span style="font-size:15px; color:red">
           * If you are a Featured and Preferred member, please remember to send a ParentFinder Message to The Writing Team, notifying them of your upload. They will assign you a coach to begin working with you.
        </span>
      </v-layout>
    </v-container>
    <!-- ParentFinder admin documents-->
    <v-container v-if="this.helpFileList.length > 0">
      <v-layout wrap class="pr-4">
        <v-flex class="xs12">
          <h5 class="pf-sub-head mb-3 custom-title">
            <b>ParentFinder Help Files</b>
          </h5>
        </v-flex>
      </v-layout>
      <v-card>
      <v-data-table
        disable-initial-sort
        :headers="documentHeaders"
        :items="helpFileList"
        class="pf-data-table"
        hide-actions
      >
        <template v-slot:items="props" >
          <td>{{ props.item.name }}</td>
          <td align="right">
            <v-btn icon class="ma-0" target="_blank" :href="config.uploadPath + props.item.file.webPath">
              <v-icon size="22" color="grey darken-2">remove_red_eye</v-icon>
            </v-btn> 
          </td>
        </template>
      </v-data-table>
    </v-card>
    </v-container>
  </div>
</template>
<script>
/* global session store config */  
import UploadButton from 'vuetify-upload-button';
import swal from 'sweetalert2';
import { create, getCollection, remove, uploadFile, formatDate, update } from '../../helpers/helpers';
import Vue from 'vue';

export default {
  components: {
    'upload-btn': UploadButton,
  },  
  data: () => ({
    entity: 'File',
    search: '',
    config: config,
    // rules: [
    //   v => !!v || 'File description is required'
    // ],
    uploadingFile: [],
    selectedData: false,
    headers: [
      { text: 'File Name', value: 'name', align: 'left' },
      { text: 'Description', value: 'description', align: 'left', width: '300px' },
      { text: 'Category', value: 'category', align: 'left', width: '300px' },
      { text: 'Date', value: 'createdAt' },
      { text: '', sortable: false },
    ],
    category: {
      Rule: (v) => !!v || 'Please select category',
    },
    pagination: {
      sortBy: 'createdAt', // The field that you're sorting by
      descending: true,
      rowsPerPage: config.dom.rowsPerPage
    },
    documentHeaders: [
      { text: 'Name', value: 'name', align: 'left' },
      { text: '', sortable: false },
    ],
    extraParams: {},
    documents: []
  }),
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  computed: {
    fileCategoryList: {
      get () {
        return store.state.FileCategory;
      },
      set (value) {
        store.commit('setFileCategory', value);
      }
    },
    File: {
      get () {
        return store.state.File;
      },
      set (value) {
        store.commit('setFile', value);
      }
    },
    Account: {
      get () {
        return store.state.Account;
      },
      set (value) {
        store.commit('setAccount', value);
      }
    },
    helpFileList: {
      get () {
        return store.state.HelpFileList;
      },
      set (value) {
        store.commit('setHelpFileList', value);
      }
    }
  },
  created () {
    this.initialize();
    this.getHelpFiles();
    this.getFileCategories();
  },
  methods: {
    async getHelpFiles () {
      if (!this.helpFileList.length) {
        if (typeof this.Account.membership !== 'undefined') {
          let where = { membership: this.Account.membership };
          let sort = { sort_no: 1 };
          let { error, data } = await getCollection('HelpFile', true, 0, '', where, null, null, sort);
          if (error) {
            console.log(error);
          } else {
            if (data.length > 0) {
              this.helpFileList = data;
            }
          }
        }
      }
    },
    async getFileCategories () {
      if (!this.fileCategoryList.length) {
        let entity = `FileCategory`;
        let { error, data } = await getCollection(entity, true);
        if (error) {
          console.log(error);
        } else {
          if (data.length > 0) {
            this.fileCategoryList = data;
          }
        }
      }
    },
    async fileSelected (fileslist) {
      this.uploadingFile = fileslist;
      let files = this.uploadingFile;
      for (let i = 0; i < files.length; i++) {
        if (files[i] !== 'undefined') {
          this.fileName = files[i].name;
          if (this.fileName.lastIndexOf('.') <= 0) {
            this.selectedData = true;
            return;
          }
          if (files[i].size > this.config.uploadFileSize) {
            swal.fire({
              title: `<strong>Upload error</strong>`,
              type: 'error',
              html: 'Maximum file upload size is ' + (this.config.uploadFileSize / 1024 / 1024) + ' MB',
              showCloseButton: true,
              showCancelButton: false,
              focusConfirm: false,
              confirmButtonText: 'Close',
            });
            this.selectedData = true;
            return;
          }
          window.getApp.$emit('AppProgress', true);
          const fr = new FileReader();
          fr.readAsDataURL(files[i]);
          fr.addEventListener('load', async () => {
            let postUrl = 'File';
            if (session.getSession().adminUser) {
              this.extraParams.account = session.getSession().user.human.account.id;
            }
            let response = await uploadFile(postUrl, files[i], 'POST', this.extraParams);
            if (!response.$data) {
              window.getApp.$emit('AppProgress', false);
              console.log('error', response.$error);
              this.snackbar = {
                show: true,
                color: 'red',
                text: response.$error
              };
            } else {
              this.File.unshift(response.$data);
              if (i + 1 === files.length) {
                // Create the timeline
                let timelineData = {
                  title: 'File(s) Uploaded',
                  text: `You've uploaded ${files.length} file(s)`,
                  account: this.Account.id
                };
                let { error, data, status } = await create('Timeline', timelineData);
                if (error) {
                  console.log('error', error);
                  this.snackbar = {
                    show: true,
                    color: 'orange',
                    text: 'Failed to create the timeline'
                  };
                } else {
                  swal.fire({
                    type: 'success',
                    title: 'File(s) uploaded successfully',
                    showConfirmButton: false,
                    timer: 2500,
                    onClose: () => {
                      window.getApp.$emit('AppProgress', false);
                    }
                  });
                }
              }
            }
          });
        }
      }
    },
    async fileEdit (item, type) {
      let updateItem = { ...item };
      let itemIndex = this.File.indexOf(item);
      let updateId = this.File[itemIndex].id;
      let { error, data, status } = await update('File', updateItem, updateId);
      if (error) {
        console.log('error', error);
        swal.fire({
          type: 'error',
          title: 'Failed to update data',
          showConfirmButton: true,
          timer: 2500,
          onClose: () => {}
        });
      } else {
        this.loading = false;
        swal.fire({
          type: 'success',
          title: `${type} updated successfully`,
          showConfirmButton: false,
          timer: 2500,
          onClose: () => {
          }
        });
      }
    },
    async initialize () {
      if (!this.File.length) {
        let sessionUser = session.getSession();
        let where = sessionUser.adminUser ? { account: sessionUser.user.human.account.id } : {};
        let { error, data, status } = await getCollection(this.entity, true, 0, '', where);
        if (error) {
          console.log(error);
          this.snackbar = {
            show: true,
            color: 'red',
            text: 'Failed to load files'
          };
        } else {
          this[this.entity] = data;
        }
      }
    },
    formatDate (dateString) {
      return formatDate(dateString, 'MM/DD/YYYY');
    },
    deleteItem (item) {
      swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
          (async () => {
            let { error, data, status } = await remove(this.entity, item.id);
            if (error) {
              console.log('error', error);
            } else {
              const index = this[this.entity].indexOf(item);
              this[this.entity].splice(index, 1);
              // Create the timeline
              let timelineData = {
                title: 'File Deleted',
                text: `You've deleted a file - '${item.name}'`,
                account: this.Account.id
              };
              let { error, data, status } = await create('Timeline', timelineData);
              if (error) {
                console.log('error', error);
                this.snackbar = {
                  show: true,
                  color: 'orange',
                  text: 'Failed to create the timeline'
                };
              } else {
                swal.fire(
                  'Deleted!',
                  'The file "' + item.name + '" has been deleted.',
                  'success'
                );
              }
            }
          })();
        }
      });

    }, 
  }
};
</script>
<style scoped style="css">
.custom-mt {
  margin-top: 6px;
}
#parentFiles >>> .v-small-dialog__content {
  width:  350px !important;
  padding: 0;
}
.v-menu__content {
  width: 400px !important;
}
#parentFiles >>> .upload-btn {
  border-radius: 50%;
  min-width: 0;
  height: 56px;
  width: 56px !important;
  padding: 0;
}
#parentFiles >>> .v-btn--icon.upload-btn {
  background-color: #7ac142 !important;
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/Files/ParentFiles.vue